<script lang="ts" setup>
defineProps<{
  as?: 'h1' | 'h2' | 'h3';
}>();
</script>

<template>
  <!-- Avec un slot #actions : le titre et le contenu à droite partagent la même ligne et le filet du bas -->
  <div v-if="$slots.actions" class="mb-4 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 border-b border-gray-200 pb-1">
    <component :is="as || 'h2'" class="2xs:text-lg xs:text-xl text-base font-semibold">
      <slot />
    </component>
    <slot name="actions" />
  </div>

  <!-- Sans slot #actions : rendu d'origine, identique partout ailleurs -->
  <component :is="as || 'h2'" v-else class="2xs:text-lg xs:text-xl mb-4 border-b border-gray-200 pb-1 text-base font-semibold">
    <slot />
  </component>
</template>

<style lang="css" scoped></style>
